import { makeStyles } from '@material-ui/styles'
import GetDialogButton from 'app/plugins/openstack/components/vms/vm-details/GetDailogButton'
import { ArrayElement } from 'core/actions/Action'
import { clientActions } from 'core/client/clientReducers'
import DocumentMeta from 'core/components/DocumentMeta'
import Button from 'core/elements/button/Button'
import { BatchActionDropdown } from 'core/elements/grid/GridToolbar'
import { GridBatchActionGroupProps } from 'core/elements/grid/hooks/useGridSelectableRows'
import { HeaderPrimaryActionPortal, HeaderRefreshPortal } from 'core/elements/header/portals'
import Tabs from 'core/elements/tabs'
import Tab from 'core/elements/tabs/Tab'
import useListAction from 'core/hooks/useListAction'
import { useSelector } from 'react-redux'
import Theme from 'core/themes/model'
import { isReadonlyUser } from 'core/utils/helpers'
import { routeManager } from 'core/utils/routes'
import { getBlueprints } from 'openstack/components/infrastructure/actions'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import useReactRouter from 'use-react-router'
import { listVolumeSnapshots } from '../actions'
import { volumeSnapshotsSelector } from '../selectors'
import { IVolumeSnapshotDetailsPageTabs } from './model'
import Overview from './Overview'

type SelectorModel = ArrayElement<ReturnType<typeof volumeSnapshotsSelector>>

const useStyles = makeStyles<Theme>((theme) => ({
  grid: {
    display: 'grid',
    gap: 32,
  },
  actions: {
    display: 'grid',
    gridAutoColumns: 'auto max-content',
    gridAutoFlow: 'column',
    gap: 16,
  },
  dropdownAction: {
    background: theme.components.dropdown.background,
    border: 'none',
    '& .button-text': {
      color: theme.components.dropdown.color,
      justifyContent: 'flex-start',
    },
  },
}))

const VolumeSnapshotDetailsPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { match } = useReactRouter()
  const { id } = match.params
  const { loading, reload: reloadVolumeSnapshots } = useListAction(listVolumeSnapshots)
  const volumeSnapshots = useSelector(volumeSnapshotsSelector)

  // Try finding VM in tenant VM list, if not found find in all Tenant's VM list
  const volumeSnapshot = useMemo(() => {
    const matchingSnapshot = volumeSnapshots?.find((snapshot) => snapshot?.id === id)
    if (matchingSnapshot) {
      return matchingSnapshot
    }
    return null
  }, [id, volumeSnapshots])

  useEffect(() => {
    dispatch(
      clientActions.updateBreadcrumbParams({
        id: volumeSnapshot?.name || id,
      }),
    )
    return () => {
      dispatch(clientActions.resetBreadcrumbParams())
    }
  }, [volumeSnapshot?.name, id])

  return (
    <>
      <DocumentMeta title="Volume Snapshot Details" breadcrumbs />
      <HeaderRefreshPortal>
        <Button
          icon="refresh"
          variant="secondary"
          onClick={() => {
            reloadVolumeSnapshots(true)
          }}
          loading={loading}
        >
          Refresh
        </Button>
      </HeaderRefreshPortal>
      <Tabs route={routeManager.routes.openstack.volumeDetails}>
        <Tab label="Overview" value={IVolumeSnapshotDetailsPageTabs.Overview}>
          <Overview snapshot={volumeSnapshot || {}} loading={loading} />
        </Tab>
      </Tabs>
    </>
  )
}

export default VolumeSnapshotDetailsPage
